import { Suspense, useMemo } from 'react';
import { Outlet } from 'react-router-dom';

import Loading from 'components/global/Loading';
import PageHeader from 'components/global/PageHeader';
import Tabs from 'components/global/Tabs';

import PATHS, { mergePaths } from 'utils/paths';

const CustomerService = () => {
	const tabs = useMemo(
		() => [
			{
				label: 'returns',
				path: mergePaths(PATHS.CUSTOMER_SERVICE, PATHS.RETURNS)
			},
			{
				label: 'failedDeliveryOrders',
				path: mergePaths(PATHS.CUSTOMER_SERVICE, PATHS.FAILED_DELIVERY_ORDERS)
			},
			{
				label: 'customerFeedbacks',
				path: mergePaths(PATHS.CUSTOMER_SERVICE, PATHS.CUSTOMER_SERVICE_FEEDBACKS)
			}
		],
		[]
	);

	return (
		<div>
			<PageHeader
				title="customerService"
				lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/customerService-icon.json.gz"
				moduleName="customer-service"
			/>
			<Tabs data={tabs} checkURL />
			<Suspense fallback={<Loading />}>
				<Outlet />
			</Suspense>
		</div>
	);
};

export default CustomerService;
